import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '@components/ui/Header';
import Footer from '@components/ui/Footer';
import PageHeader from './components/PageHeader';
import JobListings from './components/JobListings';
import CultureSection from './components/CultureSection';
import ApplicationModal from './components/ApplicationModal';

const CareerPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState('');

  const handleApplyClick = (position) => {
    setSelectedPosition(position);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedPosition('');
  };

  return (
    <>
      <Helmet>
        <title>Join Our Team - Eye&U Kenya | Career Opportunities in Eye Care</title>
        <meta name="description" content="Explore career opportunities with Kenya's leading eye care professionals. Join our team of dedicated medical experts and administrative staff." />
        <meta name="keywords" content="eye care careers, medical jobs Kenya, ophthalmologist jobs, healthcare careers, Eye U Kenya jobs" />
        <meta property="og:title" content="Join Our Team - Eye&U Kenya" />
        <meta property="og:description" content="Explore career opportunities with Kenya's leading eye care professionals. Join our team of dedicated medical experts." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Join Our Team - Eye&U Kenya" />
        <meta name="twitter:description" content="Explore career opportunities with Kenya's leading eye care professionals." />
        <link rel="canonical" href="https://eyeukenya.com/career-page" />
      </Helmet>

      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        
        <main className="flex-1">
          <PageHeader />
          <CultureSection />
          <JobListings onApplyClick={handleApplyClick} />
        </main>

        <Footer />

        {/* Application Modal */}
        <ApplicationModal 
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          selectedPosition={selectedPosition}
        />
      </div>
    </>
  );
};

export default CareerPage;